module.exports = __webpack_public_path__ + "static/media/Forgot Password 1.19df7693.svg";